module.exports = __webpack_public_path__ + "static/img/1960_06_HarpersMagazine_TudorFeature_4.aa64e52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1960_06_HarpersMagazine_TudorFeature_4.jpg
// module id = N37H
// module chunks = 0